import moment from 'moment';

import { SalesStage } from '../../../Model/Lead';

export const DEFAULT_COUNTRIES = ['US', 'CA', 'AU'];

export const COUNTRY_OPTIONS = [
  { value: 'US', label: 'US · United States' },
  { value: 'CA', label: 'CA · Canada' },
  { value: 'AU', label: 'AU · Australia' },
];

export const DEFAULT_AGE_DAYS = { min: 7, max: 14 };

export const DEFAULT_CLIENT_AGE_DAYS = { min: 30, max: 180 };

export const AUDIENCE_TYPE = {
  LEADS: 'LEADS',
  CANCELED_CLIENTS: 'CANCELED_CLIENTS',
};

export const DEFAULT_AUDIENCE_TYPE = AUDIENCE_TYPE.LEADS;

export const isClientAudience = (audienceType) => audienceType === AUDIENCE_TYPE.CANCELED_CLIENTS;

export const RECIPIENT_GROUP_OPTIONS = [
  { value: AUDIENCE_TYPE.LEADS, label: 'Leads' },
  { value: AUDIENCE_TYPE.CANCELED_CLIENTS, label: 'Canceled clients' },
];

export const CHALLENGE_ENDED_CANCELLATION_SOURCE = 'CHALLENGE_ENDED';

// GSM-7 fits 160 septets in a standalone SMS, 153 once the message is split across parts
// (the rest of the payload carries the reassembly header). A single character outside the
// GSM 03.38 alphabet forces the whole message to UCS-2, where those numbers drop to 70/67.
export const SMS_SEGMENT_LEN_GSM7 = 160;
export const SMS_CONCAT_LEN_GSM7 = 153;
export const SMS_SEGMENT_LEN_UCS2 = 70;
export const SMS_CONCAT_LEN_UCS2 = 67;

// Brevo's MMS text limit, and the hard send gate on both client and server. Mirrors the
// server's MAX_MESSAGE_LENGTH. Brevo's own composer shows 1600 for an MMS whether or not the
// body has emoji in it, so unlike SMS this limit does not halve for unicode.
export const MAX_BODY_LEN = 1600;

export const MAX_IMAGE_BYTES = 850 * 1024;
export const MAX_IMAGE_KB = Math.floor(MAX_IMAGE_BYTES / 1024);
export const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/png'];

export const SUBMIT_PHASE = {
  IDLE: 'idle',
  UPLOADING: 'uploading',
  SENDING: 'sending',
  SAVING: 'saving',
};

export const DEFAULT_SALES_STAGES = [SalesStage.LOST];

export const AUDIENCE_OPTIONS = [
  { value: SalesStage.LOST, label: 'LOST · Lost leads', shortLabel: 'Lost' },
  { value: SalesStage.UNQUALIFIED, label: 'UNQUALIFIED · Disqualified leads', shortLabel: 'Disqualified' },
];

export const PREVIEW_RECIPIENT_LIMIT = 2000;

export const MAX_CAMPAIGN_RECIPIENTS = 3500;

export const CAMPAIGN_FAILURE_STEP = {
  TOO_MANY_RECIPIENTS: 'TOO_MANY_RECIPIENTS',
};

export const PREVIEW_DEBOUNCE_MS = 400;

export const TOKENS = { LINK: '{dpl}', FIRST_NAME: '{firstName}' };

export const SAMPLE_LINK_URL = 'https://l8k1h.brv1.ac/xxxxxx';

export const SAMPLE_FIRST_NAME = 'Alexander';

export const ORG_PREFIX_FALLBACK = 'Avida';

export const COMPLIANCE_SEPARATOR_LENGTH = 3;

export const STOP_SUFFIX = 'Reply STOP to opt out';

export const EM_DASH = '—';

const audienceDates = ({ min, max }) => ({
  startDate: moment().subtract(max, 'days').startOf('day'),
  endDate: moment().subtract(min, 'days').endOf('day'),
});

export const getDefaultDatesForAudienceType = (audienceType) => (
  isClientAudience(audienceType) ? audienceDates(DEFAULT_CLIENT_AGE_DAYS) : audienceDates(DEFAULT_AGE_DAYS)
);
